import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const dashboardApi = createApi({
  reducerPath: "dashboard",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_ENDPOINT}api`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("access-token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["panels"],
  endpoints(builder) {
    return {
      fetchActivePanels: builder.query({
        providesTags: ["panels"],
        query: () => ({
          url: "/DashboardPanel/GetActivePanels",
          method: "GET",
        }),
      }),
      fetchSystemSummary: builder.query({
        query: () => ({
          url: "/DashboardPanel/SystemSummary",
          method: "GET",
        }),
      }),
      fetchQuestionnaires: builder.query({
        query: () => ({
          url: "/Questionnaire/getAll",
          method: "GET",
        }),
      }),
      createPanel: builder.mutation({
        invalidatesTags: ["panels"],
        query: (body) => ({
          url: "/DashboardPanel/CreatePanel",
          method: "POST",
          body,
        }),
      }),
      deletePanel: builder.mutation({
        invalidatesTags: ["panels"],
        query: (id) => ({
          url: `/DashboardPanel/DeletePanel/${id}`,
          method: "DELETE",
        }),
      }),
    };
  },
});

export { dashboardApi };
export const {
  useFetchActivePanelsQuery,
  useFetchSystemSummaryQuery,
  useFetchQuestionnairesQuery,
  useCreatePanelMutation,
  useDeletePanelMutation,
} = dashboardApi;
